module.exports = __webpack_public_path__ + "img/icon_succcess.8539bd27.png";